import { render, staticRenderFns } from "./ProjectsSection.vue?vue&type=template&id=82520272&"
import script from "./ProjectsSection.vue?vue&type=script&lang=js&"
export * from "./ProjectsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports